import { HttpRequest, HttpHandlerFn, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { switchMap } from 'rxjs/operators';

/**
 * HTTP interceptor that adds OIDC access token to API requests
 */
export const authInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
) => {
  const oidcSecurityService = inject(OidcSecurityService);

  // Only attach token to our API requests
  if (!req.url.startsWith('/api/')) {
    return next(req);
  }

  return oidcSecurityService.getAccessToken().pipe(
    switchMap(token => {
      if (token) {
        const authReq = req.clone({
          headers: req.headers.set('Authorization', `Bearer ${token}`),
        });
        return next(authReq);
      }
      return next(req);
    })
  );
};
